import React from "react"

// Note: jQuery ($) is loaded globally

class RateCalendar extends React.Component {
  constructor(props) {
    super(props)
    this.calendar = null
    this.setCalendarElementRef = (element) => {
      this.calendar = element
    }
    this.launchCalendar = this.launchCalendar.bind(this)
  }

  componentDidMount() {
    this.launchCalendar()
  }

  launchCalendar() {
    $(this.calendar).fullCalendar({
      header: {
        left: "prev,next today",
        center: "title",
        right: false,
      },
      events: "space_rates/projection",
      eventRender: function (event, element, view) {
        const title = element.find(".fc-title")
        title.html(title.text())
      },
      loading: function (isLoading, view) {
        if (isLoading) {
          $(".fc-view-container").append(
            '<div class="loading-calendar"><i class="icon icon-spinner icon-spin"></i></div>'
          )
        } else {
          $(".loading-calendar").remove()
        }
      },
    })
    setTimeout(() => $(this.calendar).fullCalendar("render"), 300)
  }

  render() {
    return (
      <div className="rate-calendar">
        <div className="color-key bs-mt-0 float-right">
          <div className="color-key-item">
            <div className="color-circle color-circle-weekday" />
            Weekday
          </div>
          <div className="color-key-item">
            <div className="color-circle color-circle-weekend" />
            Weekend
          </div>
          <div className="color-key-item">
            <div className="color-circle color-circle-exception" />
            Exception
          </div>
        </div>
        <div ref={this.setCalendarElementRef} />
      </div>
    )
  }
}

export default RateCalendar
